export default () => ({
  trailer: null,
  video: null,
  certificateSafari: '',
  certificateChrome: '',
  playlist: null,
  endTrailer: false,
  isTrailerList: false
})
